<template>
  <div
    class="time-submission"
    :class="{
      'disable-hover-state': isDisableHoverState
    }"
    @mouseleave="enableHoverState"
  >
    <Countdown />
    <div class="time-settings">
      <div class="time-settings-wrapper">
        <div
          v-for="item in timeLimits"
          :key="item.value"
          class="time-settings-item"
          @click.stop="setTime(item.value)"
        >
          {{ $i18nPresenter.t(item.key, {x: item.param}) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import EventBus from '@/eventBus'

import Countdown from '@/components/presentations/CountdownV3.vue'

export default {
  components: {
    Countdown,
  },
  data() {
    return {
      timeLimits: [
        { value: 30, key: 'x_sec', param: 30 },
        { value: 60, key: 'x_min', param: 1 },
        { value: 120, key: 'x_min', param: 2 },
        { value: 300, key: 'x_min', param: 5 },
      ],
      isDisableHoverState: false,
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },

  watch: {
    'slideActive.stopSubmission': {
      handler(value, oldValue) {
        if (
          (value && oldValue === undefined)
          || (!value && oldValue)
        ) {
          this.isDisableHoverState = true
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    enableHoverState() {
      this.isDisableHoverState = false
    },
    setTime(value) {
      this.isDisableHoverState = true

      this.updateSlideActiveAction({
        timeToAnswer: value,
      })
      EventBus.$emit('resetTimeToAnswer')
    },
  },
}
</script>

<style lang="scss" scoped>
.time-submission {
  position: relative;
  min-width: 160px;

  &:not(.disable-hover-state):hover {
    .time-settings {
      visibility: visible;
    }
  }

  &.freeze {
    pointer-events: none;
  }
}

.time-settings {
  visibility: hidden;
  position: absolute;
  right: 0;
  top: 100%;
  background-color: transparent;
  color: #313131;
  padding-top: 20px;

  &-wrapper {
    border-radius: 16px;
    background-color: #FFF;
    padding: 8px 0;
    width: fit-content;
    min-width: 152px;
    overflow: hidden;
  }
}

.time-settings-item {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 38px;
  cursor: pointer;

  &:hover {
    font-weight: 700;
    background-color: #F0F0F0;
  }
}
</style>
